export let upgrades = [];

//Decentrale windenergie
upgrades.push({
  id: 1,
  name: "Netwerk",
  mwuBonus: [],
  basePrice: 300,
  availability: ["city", "company", "supplier"],
  purchased: ["Sonnelect", "Wellectric"]
});

upgrades.push({
  id: 2,
  name: "Opslagcapaciteit",
  mwuBonus: [],
  basePrice: 300,
  availability: ["city", "company"],
  purchased: []
});

upgrades.push({
  id: 3,
  name: "Slim netwerk",
  mwuBonus: -3,
  basePrice: 500,
  availability: ["city"],
  purchased: []
});

upgrades.push({
  id: 4,
  name: "Slimme straatverlichting",
  mwuBonus: -2,
  basePrice: 400,
  availability: ["city"],
  purchased: []
});

upgrades.push({
  id: 5,
  name: "Slimme verdelers",
  mwuBonus: -3,
  basePrice: 500,
  availability: ["company"],
  purchased: []
});

upgrades.push({
  id: 6,
  name: "Slimme apparatuur",
  mwuBonus: -2,
  basePrice: 400,
  availability: ["company"],
  purchased: []
});



// WEBPACK FOOTER //
// ./src/actions/upgradesArray.js